export default [
    {
        "updated_at": "2020-05-03 15:31:59",
        "id": 187,
        "has_send_num": 0,
        "start_at": "2020-03-30 00:00",
        "end_at": "2020-05-15 23:59",
        "deleted_at": null,
        "buy_status": 1,
        "coupons": [
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539323",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 30,
                    "expire": "领券当日开始30天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "第2件半价券(mini卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始30天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539323",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第二件可获得半价优惠，优惠产品原价不得高于购买产品原价\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "4.5",
                    "title": "第2件半价券(mini卡)",
                    "second_max_num": 0,
                    "total_amount": 5,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第二件可获得半价优惠，优惠产品原价不得高于购买产品原价\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451347890055233536",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气mini卡",
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:21:51",
                "deleted_at": null,
                "id": 401,
                "coupon_id": "451347890055233536",
                "created_at": "2020-03-30 23:21:51",
                "coupon_num": 1,
                "packages_id": 187
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539381",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 30,
                    "expire": "领券当日开始30天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券6元元",
                    "coupon_title": "满58元减现金券6元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始30天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539381",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满58元享受6元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "2.5",
                    "title": "58-6元现金券(mini卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 6,
                    "min_amount_use": 58,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满58元享受6元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451348136147632128",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气mini卡",
                    "categorieGoods": [],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满58元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券6元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:21:51",
                "deleted_at": null,
                "id": 402,
                "coupon_id": "451348136147632128",
                "created_at": "2020-03-30 23:21:51",
                "coupon_num": 2,
                "packages_id": 187
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539573",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 30,
                    "expire": "领券当日开始30天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券10元元",
                    "coupon_title": "满108元减现金券10元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始30天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539573",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "3.5",
                    "title": "108-10元现金券(mini卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 10,
                    "min_amount_use": 108,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451348939155234817",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气mini卡",
                    "categorieGoods": [],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满108元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券10元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:21:51",
                "deleted_at": null,
                "id": 403,
                "coupon_id": "451348939155234817",
                "created_at": "2020-03-30 23:21:51",
                "coupon_num": 3,
                "packages_id": 187
            }
        ],
        "image": "https://img-shop.qmimg.cn/s23107/2020/02/29/8b6ffdfb8c8d7ab0e3.jpg",
        "status": 2,
        "third_party_name": "",
        "third_party_id": 0,
        "send_num": 0,
        "created_at": "2020-03-30 23:21:51",
        "third_desc": "",
        "amount": "20.00",
        "content": "【基本规则】\n1、成功购买后，优惠券可在奈雪点单小程序内使用或线下门店出示会员码使用。\n2、优惠券规则以优惠券使用详情为准。\n3、单笔订单仅限使用一张优惠券，且不与其他活动共享。\n4、用户购买券包使用的手机号需和小程序登录的会员手机号保持一致。\n5、如逾期未使用优惠券，优惠券将自动失效，请在有效期内使用。\n【注意】\n1、奈雪会员卡包为奈雪的茶公开售卖的一种付费卡包，成功购买，不可转赠、不可退换、不可兑换现金。\n2、此券包有效期30天。",
        "limit_num": 0,
        "num": 100000,
        "store_id": 23107,
        "title": "霸气mini卡",
        "sale_num": 16170,
        "third_status": 0
    },
    {
        "updated_at": "2020-05-03 15:37:45",
        "id": 186,
        "has_send_num": 0,
        "start_at": "2020-03-30 00:00",
        "end_at": "2020-05-15 23:59",
        "deleted_at": null,
        "buy_status": 1,
        "coupons": [
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539689",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 90,
                    "expire": "领券当日开始90天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "买3赠1券(心享卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始90天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539689",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满3件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "14",
                    "title": "买3赠1券(心享卡)",
                    "second_max_num": 0,
                    "total_amount": 0,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 3,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满3件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451349427363045376",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气心享卡",
                    "multi_range_type": 2,
                    "shop_ids": "5809,7559",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:20:39",
                "deleted_at": null,
                "id": 397,
                "coupon_id": "451349427363045376",
                "created_at": "2020-03-30 23:20:39",
                "coupon_num": 1,
                "packages_id": 186
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539716",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 90,
                    "expire": "领券当日开始90天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "第2件半价券(心享卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始90天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539716",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第二件可获得半价优惠，优惠产品原价不得高于购买产品原价\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "6",
                    "title": "第2件半价券(心享卡)",
                    "second_max_num": 0,
                    "total_amount": 5,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第二件可获得半价优惠，优惠产品原价不得高于购买产品原价\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451349537945866241",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气心享卡",
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:20:39",
                "deleted_at": null,
                "id": 398,
                "coupon_id": "451349537945866241",
                "created_at": "2020-03-30 23:20:39",
                "coupon_num": 2,
                "packages_id": 186
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539765",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 90,
                    "expire": "领券当日开始90天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券6元元",
                    "coupon_title": "满58元减现金券6元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始90天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539765",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满58元享受6元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "2.4",
                    "title": "58-6元现金券(心享卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 6,
                    "min_amount_use": 58,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满58元享受6元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451349745320648705",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气心享卡",
                    "categorieGoods": [],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满58元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券6元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:20:39",
                "deleted_at": null,
                "id": 399,
                "coupon_id": "451349745320648705",
                "created_at": "2020-03-30 23:20:39",
                "coupon_num": 5,
                "packages_id": 186
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539788",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 90,
                    "expire": "领券当日开始90天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券10元元",
                    "coupon_title": "满108元减现金券10元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始90天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539788",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "4",
                    "title": "108-10元现金券(心享卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 10,
                    "min_amount_use": 108,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451349840803979264",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气心享卡",
                    "categorieGoods": [],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满108元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券10元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:20:39",
                "deleted_at": null,
                "id": 400,
                "coupon_id": "451349840803979264",
                "created_at": "2020-03-30 23:20:39",
                "coupon_num": 5,
                "packages_id": 186
            }
        ],
        "image": "https://img-shop.qmimg.cn/s23107/2020/02/29/16c61aad4a84e7c2b5.jpg",
        "status": 2,
        "third_party_name": "",
        "third_party_id": 0,
        "send_num": 0,
        "created_at": "2020-03-30 23:20:39",
        "third_desc": "",
        "amount": "58.00",
        "content": "【基本规则】\n1、成功购买后，优惠券可在奈雪点单小程序内使用或线下门店出示会员码使用。\n2、优惠券规则以优惠券使用详情为准。\n3、单笔订单仅限使用一张优惠券，且不与其他活动共享。\n4、用户购买券包使用的手机号需和小程序登录的会员手机号保持一致。\n5、如逾期未使用优惠券，优惠券将自动失效，请在有效期内使用。\n【注意】\n1、奈雪会员卡包为奈雪的茶公开售卖的一种付费卡包，成功购买，不可转赠、不可退换、不可兑换现金。\n2、此券包有效期90天。",
        "limit_num": 0,
        "num": 100000,
        "store_id": 23107,
        "title": "霸气心享卡",
        "sale_num": 4388,
        "third_status": 0
    },
    {
        "updated_at": "2020-05-03 15:39:00",
        "id": 185,
        "has_send_num": 0,
        "start_at": "2020-03-30 00:00",
        "end_at": "2020-05-15 23:59",
        "deleted_at": null,
        "buy_status": 1,
        "coupons": [
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539833",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "multis": [
                        {
                            "name": "奈雪梦工厂海岸城店",
                            "store_id": "23107",
                            "id": "7559"
                        },
                        {
                            "name": "上海浦东机场卫星厅S2店",
                            "store_id": "23107",
                            "id": "5809"
                        }
                    ],
                    "coupon_title": "买2赠1券(分享卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539833",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满2件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "15",
                    "title": "买2赠1券(分享卡)",
                    "discount_categorie_goods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "second_max_num": 0,
                    "total_amount": 0,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 2,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满2件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451350032483667969",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气心享卡",
                    "categorieGoods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:19:05",
                "deleted_at": null,
                "id": 392,
                "coupon_id": "451350032483667969",
                "created_at": "2020-03-30 23:19:05",
                "coupon_num": 1,
                "packages_id": 185
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539870",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "multis": [
                        {
                            "name": "奈雪梦工厂海岸城店",
                            "store_id": "23107",
                            "id": "7559"
                        },
                        {
                            "name": "上海浦东机场卫星厅S2店",
                            "store_id": "23107",
                            "id": "5809"
                        }
                    ],
                    "coupon_title": "买3赠1券(分享卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539870",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满3件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "15",
                    "title": "买3赠1券(分享卡)",
                    "discount_categorie_goods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "second_max_num": 0,
                    "total_amount": 0,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 3,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满3件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451350186289872897",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气分享卡",
                    "categorieGoods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:19:05",
                "deleted_at": null,
                "id": 393,
                "coupon_id": "451350186289872897",
                "created_at": "2020-03-30 23:19:05",
                "coupon_num": 2,
                "packages_id": 185
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539930",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "multis": [
                        {
                            "name": "奈雪梦工厂海岸城店",
                            "store_id": "23107",
                            "id": "7559"
                        },
                        {
                            "name": "上海浦东机场卫星厅S2店",
                            "store_id": "23107",
                            "id": "5809"
                        }
                    ],
                    "coupon_title": "第3件半价券(分享卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539930",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第三件可获得半价优惠，优惠产品原价不得高于购买产品原价\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "7.5",
                    "title": "第3件半价券(分享卡)",
                    "discount_categorie_goods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "second_max_num": 0,
                    "total_amount": 5,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 2,
                    "explain_text": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第三件可获得半价优惠，优惠产品原价不得高于购买产品原价\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451350439177043969",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-分享卡",
                    "categorieGoods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [
                        {
                            "updated_at": "2020-04-19 21:37:47",
                            "id": 4201,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 22,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos茶饮",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:45",
                            "id": 4202,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 23,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 1,
                            "name": "pos欧包",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:39",
                            "id": 4652,
                            "sign": "2",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 26,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的茶",
                            "show_period": 0
                        },
                        {
                            "updated_at": "2020-04-19 21:37:37",
                            "id": 4654,
                            "sign": "1",
                            "pid": 0,
                            "is_prompt_category": 0,
                            "seo_keywords": "",
                            "url": "",
                            "sort": 27,
                            "icon": "",
                            "multi_store_id": 0,
                            "status": 1,
                            "is_show_backstage": 1,
                            "start_time": "00:00:00",
                            "end_time": "23:59:59",
                            "store_id": 23107,
                            "seo_description": null,
                            "type": 3,
                            "name": "奈雪的欧包",
                            "show_period": 0
                        }
                    ],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:19:05",
                "deleted_at": null,
                "id": 394,
                "coupon_id": "451350439177043969",
                "created_at": "2020-03-30 23:19:05",
                "coupon_num": 2,
                "packages_id": 185
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539965",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券6元元",
                    "multis": [
                        {
                            "name": "奈雪梦工厂海岸城店",
                            "store_id": "23107",
                            "id": "7559"
                        },
                        {
                            "name": "上海浦东机场卫星厅S2店",
                            "store_id": "23107",
                            "id": "5809"
                        }
                    ],
                    "coupon_title": "满58元减现金券6元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539965",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满58元享受6元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "3",
                    "title": "58-6元现金券(分享卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 6,
                    "min_amount_use": 58,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满58元享受6元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451350584189837312",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气心享卡",
                    "categorieGoods": [],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满58元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券6元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:19:05",
                "deleted_at": null,
                "id": 395,
                "coupon_id": "451350584189837312",
                "created_at": "2020-03-30 23:19:05",
                "coupon_num": 6,
                "packages_id": 185
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585539987",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券10元元",
                    "multis": [],
                    "coupon_title": "满108元减现金券10元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585539987",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "5",
                    "title": "108-10元现金券(分享卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 10,
                    "min_amount_use": 108,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451350676553392128",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气分享卡",
                    "categorieGoods": [],
                    "multi_range_type": 0,
                    "shop_ids": "",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满108元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券10元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:19:05",
                "deleted_at": null,
                "id": 396,
                "coupon_id": "451350676553392128",
                "created_at": "2020-03-30 23:19:05",
                "coupon_num": 6,
                "packages_id": 185
            }
        ],
        "image": "https://img-shop.qmimg.cn/s23107/2020/02/29/73065efbbe87e00753.jpg",
        "status": 2,
        "third_party_name": "",
        "third_party_id": 0,
        "send_num": 0,
        "created_at": "2020-03-30 23:19:05",
        "third_desc": "",
        "amount": "108.00",
        "content": "【基本规则】\n1、成功购买后，优惠券可在奈雪点单小程序内使用或线下门店出示会员码使用。\n2、优惠券规则以优惠券使用详情为准。\n3、单笔订单仅限使用一张优惠券，且不与其他活动共享。\n4、用户购买券包使用的手机号需和小程序登录的会员手机号保持一致。\n5、如逾期未使用优惠券，优惠券将自动失效，请在有效期内使用。\n【注意】\n1、奈雪会员卡包为奈雪的茶公开售卖的一种付费卡包，成功购买，不可转赠、不可退换、不可兑换现金。\n2、此券包有效期120天。",
        "limit_num": 0,
        "num": 100000,
        "store_id": 23107,
        "title": "霸气分享卡",
        "sale_num": 1213,
        "third_status": 0
    },
    {
        "updated_at": "2020-05-03 15:39:37",
        "id": 184,
        "has_send_num": 0,
        "start_at": "2020-03-30 00:00",
        "end_at": "2020-05-15 23:59",
        "deleted_at": null,
        "buy_status": 1,
        "coupons": [
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585540048",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "第2件半价券(欢聚卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585540048",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第二件可获得半价优惠，优惠产品原价不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "8",
                    "title": "第2件半价券(欢聚卡)",
                    "second_max_num": 0,
                    "total_amount": 5,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内购买任意茶饮或软欧包，第二件可获得半价优惠，优惠产品原价不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451350930572234753",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气欢聚卡",
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:17:24",
                "deleted_at": null,
                "id": 387,
                "coupon_id": "451350930572234753",
                "created_at": "2020-03-30 23:17:24",
                "coupon_num": 2,
                "packages_id": 184
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585540087",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "买2赠1券(欢聚卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585540087",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满2件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "16",
                    "title": "买2赠1券(欢聚卡)",
                    "second_max_num": 0,
                    "total_amount": 0,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 2,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满2件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451351095068643328",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气欢聚卡",
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:17:24",
                "deleted_at": null,
                "id": 388,
                "coupon_id": "451351095068643328",
                "created_at": "2020-03-30 23:17:24",
                "coupon_num": 2,
                "packages_id": 184
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585540128",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "买3赠1券(欢聚卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585540128",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满3件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "16",
                    "title": "买3赠1券(欢聚卡)",
                    "second_max_num": 0,
                    "total_amount": 0,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 3,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满3件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451351267828621313",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气欢聚卡",
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:17:24",
                "deleted_at": null,
                "id": 389,
                "coupon_id": "451351267828621313",
                "created_at": "2020-03-30 23:17:24",
                "coupon_num": 3,
                "packages_id": 184
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585540174",
                    "use_good_category": "限部分商品",
                    "category": 4,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 1,
                    "number": 0,
                    "m_and_n_coupon_of_n": 1,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "买A赠B券",
                    "coupon_title": "买5赠1券(欢聚卡)",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585540174",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满5件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "16",
                    "title": "买5赠1券(欢聚卡)",
                    "second_max_num": 0,
                    "total_amount": 0,
                    "min_amount_use": 0,
                    "used": 0,
                    "goods_range_num": 5,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满5件赠1件，赠送产品不得高于购买产品价格\n2. 适用商品：任意饮品或软欧包，菜单上标有红色雪花产品除外\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451351459131113472",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 1,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气欢聚卡",
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "无订单金额限制",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 1,
                    "amount": "买A赠B券",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:17:24",
                "deleted_at": null,
                "id": 390,
                "coupon_id": "451351459131113472",
                "created_at": "2020-03-30 23:17:24",
                "coupon_num": 3,
                "packages_id": 184
            },
            {
                "detail": {
                    "coupon_use_time": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "updated_at": "1585540240",
                    "use_good_category": "",
                    "category": 0,
                    "expire_days": 120,
                    "expire": "领券当日开始120天内有效",
                    "min_num": 0,
                    "number": 0,
                    "m_and_n_coupon_of_n": 0,
                    "property": 3,
                    "total": 99999999,
                    "property_text": "领取券",
                    "max_num": 0,
                    "coupon_amount": "现金券现金券10元元",
                    "coupon_title": "满108元减现金券10元元券",
                    "discountGoods": [],
                    "scene_type_desc": "仅外卖、堂食可用",
                    "expire_ymd": "领券当日开始120天内有效",
                    "couponUseTime": [
                        {
                            "use_time_start": "00:00:00",
                            "use_time_end": "23:59:59"
                        }
                    ],
                    "template_id": "",
                    "created_at": "1585540240",
                    "scene_type": 3,
                    "desc": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "finance_payment": "5.4",
                    "title": "108-10元现金券(欢聚卡)",
                    "discount_categorie_goods": [],
                    "second_max_num": 0,
                    "total_amount": 10,
                    "min_amount_use": 108,
                    "used": 0,
                    "goods_range_num": 1,
                    "explain_text": "1. 使用条件：在有效期内，购买任意饮品或软欧包满108元享受10元优惠\n2. 适用商品：任意饮品或软欧包\n3. 适用门店：奈雪内地任意门店(上海浦东机场店、奈雪梦工厂除外)\n4. 适用场景：奈雪线下门店出示会员码或“奈雪点单”小程序使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
                    "number_of_user": 0,
                    "id": "451351737996726273",
                    "use_per_person_per_day": 0,
                    "goods": [],
                    "categorie_goods": [],
                    "min_num_use": 0,
                    "expire_type": 1,
                    "goods_range_type": 0,
                    "start_at": 0,
                    "image": "https://img-shop.qmimg.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
                    "end_at": 0,
                    "coupon_label": "付费券包-霸气分享卡",
                    "categorieGoods": [],
                    "multi_range_type": 2,
                    "shop_ids": "7559,5809",
                    "show_page": 1,
                    "is_koubei": "",
                    "use_category": "满108元可用",
                    "out_biz_no": "",
                    "only_coupon": 1,
                    "status": 1,
                    "coupon_type": 0,
                    "amount": "现金券10元",
                    "is_use_time_range": 0,
                    "store_id": "23107",
                    "coupon_no": "",
                    "type": 1,
                    "discountCategorieGoods": [],
                    "discount_goods": [],
                    "is_receive": 1
                },
                "updated_at": "2020-03-30 23:17:24",
                "deleted_at": null,
                "id": 391,
                "coupon_id": "451351737996726273",
                "created_at": "2020-03-30 23:17:24",
                "coupon_num": 10,
                "packages_id": 184
            }
        ],
        "image": "https://img-shop.qmimg.cn/s23107/2020/02/28/e74279ce48190fd1c7.jpg",
        "status": 2,
        "third_party_name": "",
        "third_party_id": 0,
        "send_num": 0,
        "created_at": "2020-03-30 23:17:24",
        "third_desc": "",
        "amount": "198.00",
        "content": "【基本规则】\n1、成功购买后，优惠券可在奈雪点单小程序内使用或线下门店出示会员码使用。\n2、优惠券规则以优惠券使用详情为准。\n3、单笔订单仅限使用一张优惠券，且不与其他活动共享。\n4、用户购买券包使用的手机号需和小程序登录的会员手机号保持一致。\n5、如逾期未使用优惠券，优惠券将自动失效，请在有效期内使用。\n【注意】\n1、奈雪会员卡包为奈雪的茶公开售卖的一种付费卡包，成功购买，不可转赠、不可退换、不可兑换现金。\n2、此券包有效期120天。",
        "limit_num": 0,
        "num": 100000,
        "store_id": 23107,
        "title": "霸气欢聚卡",
        "sale_num": 523,
        "third_status": 0
    }
]
